 
export const getInitialStatePersist = (state: any) => ({
  _persist: state._persist,
  modal: {
    ...state.modal,
  },
});
